import { Document } from 'react-pdf';
import styled from 'styled-components';

export const StyledDocument = styled(Document)`
  width: ${({ $width }) => $width || 140}px;
  height: 140px;
  max-height: 140px;
`;
